import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { CheckCircle2, Rocket, Zap, Download, ShieldCheck } from 'lucide-react';
export function WholesaleProduct() {
  const learnings = ['Cómo funciona Amazon Wholesale', 'Cómo encontrar proveedores reales', 'Cómo contactar distribuidores', 'Cómo abrir cuentas mayoristas', 'Cómo analizar productos rentables', 'Cómo calcular ganancias', 'Cómo usar Keepa y RevSeller', 'Cómo vender marcas conocidas', 'Cómo escalar inventario', 'Cómo evitar errores comunes'];
  const miniList = ['Cómo funciona Amazon Wholesale', 'Cómo conseguir proveedores y marcas reales', 'Cómo abrir cuentas mayoristas', 'Cómo analizar la rentabilidad antes de comprar', 'Cómo utilizar Seller Central para Wholesale', 'Bonos Premium incluidos'];
  return <section className="bg-brand-beige py-24 px-6" data-id="element-1091">
      <div className="max-w-6xl mx-auto" data-id="element-1092">
        {/* Title */}
        <FadeIn data-id="element-1093">
          <div className="text-center mb-16" data-id="element-1094">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-green/10 rounded-full mb-6" data-id="element-1095">
              <Rocket className="w-8 h-8 text-brand-green" data-id="element-1096" />
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-green leading-tight" data-id="element-1097">
              🚀 ¿YA DOMINASTE FBA Y FBM?
            </h2>
            <p className="text-xl md:text-2xl font-semibold text-brand-gold mt-3" data-id="element-1098">
              Da el siguiente paso con Amazon Wholesale.
            </p>
          </div>
        </FadeIn>

        {/* Two-column block */}
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16 mb-20" data-id="element-1099">
          {/* Image */}
          <div className="flex-1 w-full" data-id="element-1100">
            <FadeIn data-id="element-1101">
              <img src="https://cdn.magicpatterns.com/uploads/wrvKYK6cQppoCoVsxXPT6X/principal_wh.png" alt="Amazon FBA Wholesale Desde Cero" className="w-full h-auto rounded-2xl shadow-2xl object-contain" data-id="element-1102" />
            </FadeIn>
          </div>

          {/* Text + button */}
          <div className="flex-1 w-full text-center lg:text-left" data-id="element-1103">
            <FadeIn delay={0.2} data-id="element-1104">
              <h3 className="text-3xl md:text-4xl font-bold text-brand-green leading-tight mb-6" data-id="element-1105">
                AMAZON FBA WHOLESALE DESDE CERO (2026)
              </h3>

              <p className="text-lg text-brand-text/80 mb-6 leading-relaxed" data-id="element-1106">
                Accede al siguiente nivel aprendiendo a vender productos de
                marcas reconocidas en Amazon utilizando el modelo Wholesale.
                Descubre cómo abrir cuentas mayoristas, negociar con marcas y
                construir un negocio más estable y escalable.
              </p>

              <div className="space-y-3 mb-8 text-left max-w-md mx-auto lg:mx-0" data-id="element-1107">
                {miniList.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-1108">
                    <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-1109" />
                    <p className="text-base text-brand-text/80 font-medium" data-id="element-1110">
                      {item}
                    </p>
                  </div>)}
              </div>

              {/* Price */}
              <div className="mb-5" data-id="element-1111">
                <div className="mb-3 lg:text-left text-center" data-id="element-1112">
                  <span className="inline-block text-[11px] font-bold tracking-[0.15em] text-brand-gold bg-brand-gold/10 border border-brand-gold/30 px-3 py-1 rounded-full" data-id="element-1113">
                    SIGUIENTE NIVEL PARA ESCALAR
                  </span>
                </div>
                <p className="text-xs font-semibold uppercase tracking-wider text-brand-text/50 mb-1 lg:text-left text-center" data-id="element-1114">
                  🔥 HOY SOLO
                </p>
                <div className="flex items-baseline justify-center lg:justify-start gap-3 mb-2" data-id="element-1115">
                  <p className="text-5xl md:text-6xl font-bold text-brand-green" data-id="element-1116">
                    $19.99
                  </p>
                  <p className="text-xl line-through font-semibold text-brand-text/40" data-id="element-1117">
                    $67 USD
                  </p>
                </div>
                <p className="text-xs font-bold text-brand-gold uppercase tracking-wider lg:text-left text-center" data-id="element-1118">
                  ⚡ Precio de lanzamiento — puede cambiar en cualquier momento
                </p>
              </div>

              <Button onClick={() => window.open('https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-wholesale-desde-cero-2026', '_blank', 'noopener,noreferrer')} className="w-full sm:w-auto text-lg px-10 py-5" data-id="element-1119">
                QUIERO APRENDER WHOLESALE
              </Button>
              <div className="flex flex-col sm:flex-row items-center lg:justify-start justify-center gap-4 sm:gap-6 text-brand-text/50 text-xs mt-4" data-id="element-1120">
                <span className="flex items-center gap-1.5" data-id="element-1121">
                  <Zap className="w-3.5 h-3.5 text-brand-green" data-id="element-1122" />
                  ACCESO INMEDIATO
                </span>
                <span className="flex items-center gap-1.5" data-id="element-1123">
                  <Download className="w-3.5 h-3.5 text-brand-green" data-id="element-1124" />
                  DESCARGA DIGITAL
                </span>
                <span className="flex items-center gap-1.5" data-id="element-1125">
                  <ShieldCheck className="w-3.5 h-3.5 text-brand-green" data-id="element-1126" />
                  COMPRA SEGURA
                </span>
              </div>
              <p className="text-sm text-brand-text/60 mt-5 lg:text-left text-center max-w-md mx-auto lg:mx-0 leading-relaxed" data-id="element-1127">
                Ideal para quienes ya dominan FBA o FBM y quieren vender marcas
                reconocidas con mayor potencial de crecimiento.
              </p>
            </FadeIn>
          </div>
        </div>

        {/* Lo que aprenderás */}
        <div className="max-w-4xl mx-auto" data-id="element-1128">
          <FadeIn delay={0.15} data-id="element-1129">
            <div className="bg-white rounded-2xl p-8 md:p-10" data-id="element-1130">
              <div className="flex items-center gap-3 mb-3" data-id="element-1131">
                <Rocket className="w-6 h-6 text-brand-gold" data-id="element-1132" />
                <h3 className="text-xl md:text-2xl font-bold text-brand-green" data-id="element-1133">
                  ¿QUÉ APRENDERÁS CON AMAZON WHOLESALE?
                </h3>
              </div>
              <p className="text-brand-text/70 mb-6" data-id="element-1134">
                Aprende cómo muchas personas están utilizando el modelo
                Wholesale para vender productos de marcas reconocidas dentro de
                Amazon.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1135">
                {learnings.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-1136">
                    <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-1137" />
                    <p className="text-base md:text-lg text-brand-text/80 font-medium" data-id="element-1138">
                      {item}
                    </p>
                  </div>)}
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}